import React, { useEffect, useState } from 'react'
import BreadCrumb from '../Components/BreadCrumb'
import Search from '../Components/Search'
import { useNavigate } from 'react-router'
import dummy from '../Assets/Images/Employee/dummy.jpg'
import { employeeFromDatabase } from '../Utils/dummy_data'
import '../Assets/Styles/People.css'
import PeopleMainContent from '../Components/PeopleMainContent'
import Loading from '../Components/Loading'

const People = () => {
    const navigate = useNavigate()

    useEffect(() => {
        document.getElementById('head-title').text = 'People | Tiller'
    }, [])
    const handleEmployeeClick = (emp) => {

        navigate(`/people/${emp.emp_id?.toLowerCase()}`)
    }

    const [employees, setEmployees] = useState([])
    const [searchText, setSearchText] = useState("")
    const [selectedItem, setSelectedItem] = useState({ item: 'Senior Management', index: 0 });
    const [isLoading, setIsLoading] = useState(true);


    const onImageError = (e) => {
        e.target.src = dummy
    }
    const handleCheck = (e, item, index) => {

        setSelectedItem({ item: item, index: index })

    }
    const departments = Object.keys(employeeFromDatabase)

    useEffect(() => {
        const x = document.getElementById('marker')
        const ty = (50 / departments.length) * selectedItem.index
        if (x)
            x.style.transform = `translateY(${ty}%)`
    }, [selectedItem]);
    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 3000)
    }, []);

    useEffect(() => {
        const header_ele = document.getElementsByClassName('header')
        const breadcrumb_ele = document.getElementsByClassName('breadcrumbs-container')
        header_ele[0]?.classList?.remove('header')
        breadcrumb_ele[0]?.classList?.remove('breadcrumbs-container')
      }, [])

    return (
        <div className='h-[calc(87.2*10px)] '>
            <BreadCrumb />
            <div className=' h-full overflow-hidden '>
                <div className="popup h-[calc(100%-40px)]  overflow-hidden flex">
                    <div className="tabs overflow-hidden ">
                        {departments.map((item, index) => {
                            return (<>
                                <input type="radio" id={item} name="tab" checked={item === selectedItem.item}
                                    onChange={(e) => handleCheck(e, item, index)} />
                                <label for={item}>{item}</label>
                            </>)

                        })}



                        <div id='marker' class={`marker`}>
                            <div id="top"></div>
                            <div id="bottom"></div>
                        </div>

                    </div>

                    <PeopleMainContent department={selectedItem.item} onImageError={onImageError} />
                </div >
            </div>


        </div>
    )
}

export default People

